import { render, staticRenderFns } from "./CustomerPermissions.vue?vue&type=template&id=c0ed2b50&scoped=true"
import script from "./CustomerPermissions.vue?vue&type=script&lang=js"
export * from "./CustomerPermissions.vue?vue&type=script&lang=js"
import style0 from "./CustomerPermissions.vue?vue&type=style&index=0&id=c0ed2b50&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_cache-loader@4.1.0_css-loader@3.6.0_vue-template-compiler@2.7.16_webpack@4.47.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0ed2b50",
  null
  
)

export default component.exports